export default "__VITE_ASSET__MJxtLY1k__"